import {
  AktSparte,
  KundenterminStatus,
  TerminBerichtUrgentStatus,
  TerminRueckfrageAnStatus,
} from "../enums/global-enums";
import { Injectable } from "@angular/core";

type Option<T> = { label: string; value: T };
interface OptionConfig<T> {
  enumObj: T;
  labels: Record<keyof T, string>;
  prefix?: string;
  includeNullOption?: boolean;
  nullText?: string;
  includeValues?: T[keyof T][];
}

@Injectable({
  providedIn: "root",
})
export class TerminService {
  constructor() {}

  kundenterminLabels: Record<keyof typeof KundenterminStatus, string> = {
    Vereinbart: "wurde vereinbart",
    SpaeterVNNichtErreicht: "spätere Vereinbarung (VN nicht erreicht)",
    NichtMoeglichPostweg: "Vereinbarung nicht möglich -> Postweg (BO)",
    GeraetAufPostweg: "Gerät auf dem Postweg (+ 9 Tage ab heute)",
    PoststueckEingelangt: "Poststück eingelangt",
    SpaeterMoeglich: "Vereinbarung erst später möglich",
  };

  MSR_VALUES = [
    KundenterminStatus.Vereinbart,
    KundenterminStatus.SpaeterVNNichtErreicht,
    KundenterminStatus.NichtMoeglichPostweg,
    KundenterminStatus.SpaeterMoeglich,
  ];

  TECHNIK_VALUES = [
    KundenterminStatus.Vereinbart,
    KundenterminStatus.SpaeterVNNichtErreicht,
    KundenterminStatus.GeraetAufPostweg,
    KundenterminStatus.PoststueckEingelangt,
    KundenterminStatus.SpaeterMoeglich,
  ];

  rueckfrageAnLabels: Record<keyof typeof TerminRueckfrageAnStatus, string> = {
    Abgeschlossen: "abgeschlossen (heute)",
    WeitereRecherche: "weitere Recherche (+7 Tage ab heute)",
    UeberBOVersendet: "über BO versendet",
  };

  berichtUrLabels: Record<keyof typeof TerminBerichtUrgentStatus, string> = {
    RueckstellungKurzinfo: "Rückstellung Kurzinfo VU (nur E-Mail)",
    Verzoegerungsinfo: "Verzögerungsinfo VU (+7 Tage ab heute)",
  };

  buildTerminOptions<T extends Record<string, string>>(
    config: OptionConfig<T>,
  ): Option<T[keyof T]>[] {
    const {
      enumObj,
      labels,
      prefix = "",
      includeNullOption = false,
      nullText = "für alle verfügbar",
      includeValues = Object.values(enumObj),
    } = config;

    const result: Option<any>[] = [];

    if (includeNullOption) {
      result.push({ label: nullText, value: null });
    }

    for (const value of includeValues) {
      const key = Object.entries(enumObj).find(
        ([k, v]) => v === value,
      )?.[0] as keyof T;
      if (!key) continue;

      const label = labels[key];
      const finalLabel = prefix ? `${prefix} ${label}` : label;

      result.push({ label: finalLabel, value });
    }

    return result;
  }

  isKundenterminBestaetigenAllowed(
    type: string,
    subStatusTarifart: string,
    isKundentermin: boolean,
    kundenterminErledigt: boolean,
    aktSparte: string,
  ): boolean {
    return (
      type !== "Rechnungsprüfstelle" &&
      subStatusTarifart !== "RECHNUNGSPRUEFUNG_OFFEN" &&
      subStatusTarifart !== "Rechnungsprüfung" &&
      isKundentermin &&
      kundenterminErledigt === false &&
      (aktSparte == AktSparte.Mobil ||
        aktSparte == AktSparte.Technik ||
        aktSparte == AktSparte.Diverse)
    );
  }

  isKundenterminWeitersetzenAllowed(
    type: string,
    subStatusTarifart: string,
    isKundentermin: boolean,
    kundenterminErledigt: boolean,
    aktSparte: string,
  ): boolean {
    return (
      type !== "Rechnungsprüfstelle" &&
      subStatusTarifart !== "RECHNUNGSPRUEFUNG_OFFEN" &&
      subStatusTarifart !== "Rechnungsprüfung" &&
      isKundentermin &&
      kundenterminErledigt === false &&
      aktSparte === AktSparte.Technik
    );
  }
}
